import { CONTRACT_ROLES, DOCSTORE_ROLES, RSP_ROLES } from "../../enums/admin-enum";

export const menuItemHomePage = [
  {
    name: 'WIND',
    children: [
      {
        name: 'Wind Portfolio',
        url: 'https://www.ge.com/renewableenergy/wind-energy'
      },
      {
        name: 'Onshore Wind Turbines',
        url: 'https://www.ge.com/renewableenergy/wind-energy/onshore-wind'
      },
      {
        name: 'Offshore Wind Turbines',
        url: 'https://www.ge.com/renewableenergy/wind-energy/offshore-wind'
      },
      {
        name: 'Wind Turbine Blades',
        url: 'https://www.ge.com/renewableenergy/wind-energy/leading-wind-turbine-blade-technology'
      },
      {
        name: 'Commercial Partnering & PPA',
        url: 'https://www.ge.com/renewableenergy/wind-energy/commercial-partnering-development'
      }
    ]
  },
  {
    name: 'HYDRO',
    children: [
      {
        name: 'Hydro Portfolio',
        url: 'https://www.ge.com/renewableenergy/hydro-power'
      },
      {
        name: 'Large Hydro',
        url: 'https://www.ge.com/renewableenergy/hydro-power/large-hydropower-solutions'
      },
      {
        name: 'Small Hydro',
        url: 'https://www.ge.com/renewableenergy/hydro-power/small-hydropower-solutions'
      },
      {
        name: 'Micro Hydro',
        url: 'https://www.ge.com/renewableenergy/hydro-power/micro-hydropower-kinetics-solutions'
      },
      {
        name: 'Pumped Hydro Storage',
        url: 'https://www.ge.com/renewableenergy/hydro-power/hydro-pumped-storage'
      }
    ]
  },
  {
    name: 'HYBRID',
    children: [
      {
        name: 'Hybrid Portfolio',
        url: 'https://www.ge.com/renewableenergy/hybrid'
      },
      {
        name: 'Solar Solutions',
        url: 'https://www.ge.com/renewableenergy/hybrid/solar-solutions'
      },
      {
        name: 'Energy Storage',
        url: 'https://www.ge.com/renewableenergy/hybrid/battery-energy-storage'
      },
      {
        name: 'Distributed Energy Solutions',
        url: 'https://www.ge.com/renewableenergy/hybrid/distributed-energy-solutions'
      }
    ]
  },
  {
    name: 'GRID',
    children: [
      {
        name: 'High/Medium Voltage Equipment',
        url: 'http://www.gegridsolutions.com/HVMV_Equipment.htm'
      },
      {
        name: 'Automation & Protection',
        url: 'http://www.gegridsolutions.com/automation_protection.htm'
      },
      {
        name: 'Systems & Services',
        url: 'http://www.gegridsolutions.com/Power_Projects.htm'
      },
    ]
  },
  {
    name: 'DIGITAL',
    children: [
      {
        name: 'Digital Wind Solutions',
        url: 'https://www.ge.com/renewableenergy/wind-energy/onshore-wind/digital-wind-farm'
      },
      {
        name: 'Digital Hydro Solutions',
        url: 'https://www.ge.com/renewableenergy/digital-solutions/digital-hydro-plant'
      },
      {
        name: 'Digital Solar Solutions',
        url: 'https://www.ge.com/renewableenergy/digital-solutions/digital-solar-plant'
      },
      {
        name: 'Digital Grid Solutions',
        url: 'https://www.gegridsolutions.com/Software_Solutions/Services.htm'
      }
    ]
  },
  {
    name: 'SERVICES',
    children: [
      {
        name: 'Onshore Wind Services',
        url: 'https://www.ge.com/renewableenergy/wind-energy/onshore-wind/services'
      },
      {
        name: 'Offshore Wind Services',
        url: 'https://www.ge.com/renewableenergy/wind-energy/offshore-wind/services'
      },
      {
        name: 'Hydro Services',
        url: 'https://www.ge.com/renewableenergy/hydro-power/services'
      },
      {
        name: 'Grid Services',
        url: 'https://www.gegridsolutions.com/services.htm'
      },
    ]
  },
  {
    name: 'ABOUT US',
    children: [
      {
        name: 'Summary',
        url: 'https://www.ge.com/renewableenergy/about-us'
      },
      {
        name: 'Leadership',
        url: 'https://www.ge.com/renewableenergy/about-us/meet-our-executives'
      },
      {
        name: 'Locations',
        url: 'https://www.ge.com/renewableenergy/about-us/locations'
      },
      {
        name: 'Careers',
        url: 'https://www.ge.com/renewableenergy/about-us/careers'
      },
      {
        name: 'Suppliers',
        url: 'https://www.ge.com/renewableenergy/suppliers'
      },
      {
        name: 'Health and Safety',
        url: 'https://www.ge.com/renewableenergy/sites/default/files/RE EHS 1.1 P 01_EHS Policy_Rev 1.1_EN_Final.pdf'
      }
    ]
  },
  {
    name: 'NEWS',
    children: [
      {
        name: 'Summary',
        url: 'https://www.ge.com/renewableenergy/newsroom'
      },
      {
        name: 'Press Releases',
        url: 'https://www.ge.com/renewableenergy/newsroom/press-releases'
      },
      {
        name: 'Stories',
        url: 'https://www.ge.com/renewableenergy/stories'
      },
      {
        name: 'Downloads',
        url: 'https://www.ge.com/renewableenergy/about-us/downloads'
      },
      {
        name: 'Media Contacts',
        url: 'https://www.ge.com/renewableenergy/about-us/media-contacts'
      }
    ]
  }
];

export const MENU_PORTAL = [
  {
    name: 'Application Request Access',
    url: '/application-catalog',
    redirectTo: 'APPLICATiON_CATALOG'
  },
  {
    name: 'Application Training Documents',
    url: '/application-training-document',
    redirectTo: 'APPLICATION_TRANING_DOCUMENT'
  },
  {
    name: 'Documents',
    url: '/ge-confidential-documents',
    redirectTo: 'GE_CONFIDENTIAL_DOCUMENTS'
  },
  // {
  //   name: 'Wiki',
  //   url: '',
  // }
];



export const SRM = [
  {
    name: 'SRM Scorecard',
    url: '/srm/score-card',
    permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.OPERATOR_ACCESS,
      RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
  },
  {
    name: 'SRM News',
    url: '/srm/news',
    permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.OPERATOR_ACCESS,
      RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
  },
  {
    name: 'SRM Admin',
    url: '/srm/admin',
    permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.EOL_ADMIN]
  }
];

export const CONTRACT = [
  {
    name: 'Contract Management Home',
    url: '/contracts',
    permissions: [RSP_ROLES.ADMIN, CONTRACT_ROLES.CONTRACT_ADMIN, CONTRACT_ROLES.CONTRACT_EDITOR, CONTRACT_ROLES.CONTRACT_VIEWER]
  },
  {
    name: 'Contract Management Admin',
    url: '/srm/admin/contract-access',
    permissions: [RSP_ROLES.ADMIN, CONTRACT_ROLES.CONTRACT_ADMIN]
  }
];

export const DOCSTORE = [
  {
    name: 'DocStore Home',
    url: '/docstore',
    permissions: [RSP_ROLES.ADMIN, DOCSTORE_ROLES.DOCSTORE_ADMIN, DOCSTORE_ROLES.DOCSTORE_EDITOR, DOCSTORE_ROLES.DOCSTORE_VIEWER]
  },
  {
    name: 'DocStore Admin',
    url: '/srm/admin/docstore-access',
    permissions: [RSP_ROLES.ADMIN, DOCSTORE_ROLES.DOCSTORE_ADMIN]
  }
];

export const EOL = [
  {
    name: 'Destruction Forms',
    url: '/eol/destruction',
    permissions: [RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN, RSP_ROLES.SUPPLIER]
  },
  {
    name: 'Recycling Forms',
    url: '/eol/recycling',
    permissions: [RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN, RSP_ROLES.SUPPLIER]
  },
];

export enum AUTHORIZED {
  SRM = 0,
  CONTRACT = 1,
  DOCSTORE = 2,
  RSP = 3
}


